var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-component',{attrs:{"title":"Application Submitted"}}),_c('application-submit-success-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }